import request from '@/utils/request'
const qs = require('qs')
export function grandTotalPenjualanBulanIni(data) {
  return request({
    url: '/dashboard/grand_total_penjualan_bulan_ini',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}

export function cabangList(data) {
  return request({
    url: '/cabang/list',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalDefecta(data) {
  return request({
    url: '/dashboard/total_defecta',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalNoStockNoExpired(data) {
  return request({
    url: '/dashboard/total_no_stock_no_expired',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}


// WEBPACK FOOTER //
// ./src/api/monitoring.js